import { ReactElement, ReactNode } from "react";
import { Box, Text } from "@mantine/core";

interface ILineItemRowProps {
  label: ReactNode;
  quantity?: ReactNode;
  total?: ReactNode;
}

/**
 * One row of the instance card's invoice list. Exactly three children, in
 * order — the billing-card test reads them positionally.
 */
export function LineItemRow({
  label,
  quantity,
  total,
}: ILineItemRowProps): ReactElement {
  return (
    <li>
      <Text fz="md">{label}</Text>
      <Text c="gray.4" ml="xs" fz="sm">
        {quantity}
      </Text>
      <Box ml="auto" fz="sm">
        {total}
      </Box>
    </li>
  );
}
